import { firestore } from 'firebase-admin';
export const getTimeStamp = (): Date => {
    return new Date();
};